import { t } from "@/i18n-js/instance";
import { useEmailHubModal } from "@/react/components/shared/EmailHub/LandingPage/Modal";
import { Button } from "@circle-react-shared/uikit/Button";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const InactiveState = () => {
  const emailHubModal = useEmailHubModal();

  return (
    <div className="dark:bg-tertiary border-primary my-6 rounded-lg border bg-blue-100 px-8 py-7">
      <div className="mb-2">
        <Typography.TitleSm weight="medium">
          {t("settings.billing.email_hub.inactive_state.title")}
        </Typography.TitleSm>
      </div>
      <div className="mb-4">
        <Typography.BodySm color="secondary">
          {t("settings.billing.email_hub.inactive_state.description")}
        </Typography.BodySm>
      </div>
      <div>
        <Button onClick={() => emailHubModal.show()} variant="secondary">
          <Typography.LabelSm weight="medium">
            {t("settings.billing.email_hub.inactive_state.enable_button")}
          </Typography.LabelSm>
        </Button>
      </div>
    </div>
  );
};
